// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__2Mapd","titleContainer":"Projects_titleContainer__1575B","title":"Projects_title__yBbeZ"};